<script setup>
import { computed } from 'vue';

import Icon from './Icon.vue';

defineOptions({ name: 'DsButton', inheritAttrs: false });

const props = defineProps({
  variant: { type: String, default: 'secondary' },
  size: { type: String, default: 'md' },
  iconLeft: { type: String, default: null },
  iconRight: { type: String, default: null },
  loading: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  fullWidth: { type: Boolean, default: false },
  as: { type: String, default: 'button' }
});

const cls = computed(() => [
  'ds-btn',
  `ds-btn--${props.variant}`,
  `ds-btn--${props.size}`,
  { 'is-loading': props.loading, 'is-fullwidth': props.fullWidth }
]);

const iconSize = computed(() => (props.size === 'xs' ? 12 : props.size === 'lg' ? 16 : 14));
</script>

<template>
  <component
    :is="as"
    :class="cls"
    :disabled="(disabled || loading) || undefined"
    v-bind="$attrs"
  >
    <Icon
      v-if="iconLeft && !loading"
      :name="iconLeft"
      :size="iconSize"
    />
    <span
      v-if="loading"
      class="ds-btn__spinner"
      aria-hidden="true"
    />
    <span
      v-if="$slots.default"
      class="ds-btn__label"
    ><slot /></span>
    <Icon
      v-if="iconRight"
      :name="iconRight"
      :size="iconSize"
    />
  </component>
</template>
